export default __webpack_public_path__ + "static/media/clem-onojeghuo-3.e8e42349.jpg";